.user-avatar {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 10px;
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 700;
  color: var(--color-on-accent);
  text-transform: uppercase;
  flex-shrink: 0;
  box-shadow: 0 2px 6px var(--color-shadow-strong);
}

.user-avatar--sm {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  font-size: 0.95rem;
}

.user-avatar--md {
  font-size: 1.15rem;
}

.user-avatar--opponent {
  background: linear-gradient(135deg, #8B6F5C 0%, var(--color-brown-dark, #5D4037) 100%);
}

.user-avatar--self {
  background: linear-gradient(135deg, var(--color-forest-medium, #3D8B40) 0%, var(--color-forest-dark, #2C5F2D) 100%);
}

/* Contenitore del pezzo in miniatura: il disegno lo fa <PieceSwatch> (un vero
   <Piece>), così forma, stile 3D e colori seguono le preferenze senza duplicare
   qui i gradienti — che è ciò che faceva la versione precedente. */
.user-avatar-piece-indicator {
  position: absolute;
  right: -6px;
  bottom: -6px;
  display: block;
  line-height: 0;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3));
}
